/**
 * @file Component for displaying profile and changing language.
 * @author Maarten Lensink
 */
import { OnInit } from '@angular/core';
import { OverlayService } from '../../core/overlay.service';
import { OverlayProvider } from '../../ui/overlay-provider';
import { AuthenticationService } from '../../authentication.service';
/**
 * Component for displaying profile and changing language.
 *
 * @export
 * @class AccountComponent
 * @implements {OnInit}
 */
var AccountComponent = /** @class */ (function () {
    /**
    * Creates an instance of AccountComponent.
    * @param {AuthenticationService} authenticationService
    * @param {OverlayProvider} overlayProvider
    * @param {OverlayService} overlayService
    * @memberof AccountComponent
    */
    function AccountComponent(authenticationService, overlayProvider, overlayService) {
        this.authenticationService = authenticationService;
        this.overlayProvider = overlayProvider;
        this.overlayService = overlayService;
    }
    /**
     * Sets the configuration and user.
     */
    AccountComponent.prototype.ngOnInit = function () {
        if (!this.overlayProvider || !this.overlayProvider.entity || this.overlayProvider.configuration.components.length === 0) {
            return;
        }
        this.configuration = this.overlayProvider.configuration.components[0].configuration;
        this.user = this.overlayProvider.entity;
    };
    /**
     * Closes the overlay.
     * @param {any} event The parameter is not used.
     */
    AccountComponent.prototype.closeOverlay = function (event) {
        this.overlayService.closeOverlay();
    };
    /**
     * Perform log out from authentication service.
     */
    AccountComponent.prototype.doLogout = function (event) {
        event.stopPropagation();
        this.overlayService.closeOverlay();
        this.authenticationService.logOut();
        return false;
    };
    return AccountComponent;
}());
export { AccountComponent };
